module.exports = __webpack_public_path__ + "media/images/smart_phone/portal/slide_05-8699b2f8650371ca97e27e42fcc7af53.jpg";